import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "v-radio__marker" }, null, -1)

import { computed } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  __name: 'VRadio',
  props: {
    value: null,
    modelValue: null,
    label: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { value?: string | number, modelValue?: string | number, label?: string }




const onClick = () => {
  emit("update:modelValue", props.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-radio", { checked: props.modelValue === props.value }]),
    onClick: onClick
  }, [
    _hoisted_1,
    _createTextVNode(" " + _toDisplayString(props.label), 1)
  ], 2))
}
}

})